module.exports = __webpack_public_path__ + "img/flota-auto.ac3c09ba.svg";